import { Box, useFieldArray, useFormContext } from '@agrotoken-tech/ui';
import React from 'react';
import { EquityInfoDocument } from './EquityInfoDocument';

interface Props {
  name: string;
  isDocumentRequired?: boolean;
  label: string;
}

export const MultipleEquityInfoDocument = ({ name, label }: Props) => {
  const { control } = useFormContext();
  const { fields: fieldsArray } = useFieldArray({
    control: control,
    name,
  });

  return (
    <>
      {fieldsArray.map((field, index) => {
        const fieldPrefix = `${name}.${index}`;
        const labelWithNumber = `${label} ${index + 1}`;

        return (
          <Box key={field.id}>
            <EquityInfoDocument
              fieldPrefix={fieldPrefix}
              label={labelWithNumber}
            />
          </Box>
        );
      })}
    </>
  );
};
